import { render, staticRenderFns } from "./CreatePatient.vue?vue&type=template&id=2b754596&scoped=true&"
import script from "./CreatePatient.vue?vue&type=script&lang=js&"
export * from "./CreatePatient.vue?vue&type=script&lang=js&"
import style0 from "./CreatePatient.vue?vue&type=style&index=0&id=2b754596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b754596",
  null
  
)

export default component.exports